import { render } from "./index.vue?vue&type=template&id=9f040776&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=9f040776&lang=scss&scoped=true"

import exportComponent from "/Users/howard/Repos/the-last-word/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f040776"]])

export default __exports__